import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RemoteDesktopManager } from '../ngx-remote-desktop/services/remote-desktop-manager.service';

@Component({
	selector: 'lib-remote-console-clipboard-modal',
	templateUrl: './clipboardmodal.component.html',
	styleUrls: ['./clipboardmodal.component.css']
})
export class ClipboardModalComponent implements OnInit {

	_manager: RemoteDesktopManager;
	@Input() set manager(_manager: RemoteDesktopManager) {
		this._manager = _manager;

		if (this._manager) {
			this.clipboardSubscription = this.manager.onRemoteClipboardData;
			this.clipboardSubscription.subscribe((data: string) => {
				this.text = data;
			});	
		}
	}
	get manager(): RemoteDesktopManager {
		return this._manager;
	}

	text = '';
	private clipboardData = [];
	private clipboardSubscription: any;

	constructor(public activeModal: NgbActiveModal) {
	}

	ngOnInit() {
	}

	public close() {
		this.activeModal.close(null);
	}

	submit() {
		this.activeModal.close(this.text);
	}

}
